<template>
<!-- 精选商品跳的详情列表页 -->
  <div class="can_eat_detail_page">
    <span class="gobackBtn" @click="goBack">
      <img src="./../../assets/images/icon/back1.png" class="backimg" alt />
    </span>
    <section class="section">
      <div class="introduction">
        <!-- <span class="pic"> -->
          <img class="picture" :src="detailObj.picture" alt="">
        <!-- </span> -->
        <div class="review" v-if="detailObj.reviewInformation">
          <div class="review-icon"><img src="../../assets/images/canEat/star.png" alt=""></div>{{detailObj.reviewInformation}}</div>
        <!-- <Caption class="intro"  v-if="detailObj.introduction">简介</Caption> -->
        <!-- <div class="explain"  v-if="detailObj.introduction">{{detailObj.introduction}}</div> -->
        <div class="explain"  v-if="detailObj.introduction">
          <div class="tips_content">
            <Caption type="simple font16" class="smail_tips">
              <img class="tips_icon" src="./../../assets/images/canEat/tip_icon.png" alt="">
              <font class="font">简介</font>
            </Caption>
            <p>{{detailObj.introduction}}</p>
          </div>
        </div>

      </div>
      <!-- 商品/食谱卡片 -->
      <div class="swiper-car" v-show="num1!=0">
          <mySwiper
            :slidesNum="1"
            :autoplayNumber="5000"
            :swipeid="'canEatList-repice'"
            :paginationFlag="eatList.length > 1 ? true : false"
            :autoplay="eatList.length > 1 ? true : false"
            :loop="false"
            v-if="eatList.length > 1"
          >
            <!-- 食谱卡片 -->
            <div
              class="swiper-slide"
              slot="swiper-con"
              v-for="(item, index) in eatList"
              :key="index"
              @click="goto(item)"
            >
              <div class="swiper-slide-card" v-if="item.recommendType==1">
                  <div class="canEat-img" v-if="item.recommendType==1">
                  <img style="object-fit: cover !important;" :src="item.img_url" alt="" :onerror="supplementImg">
                </div>
                <div class="canEat-cent" v-if="item.recommendType==1">
                  <div class="canEat-title">
                    {{item.recommendInfo}}
                  </div>
                  <div class="canEat-txt">
                    {{item.recommendName}}
                  </div>
                  <div class="canEat-num">
                    {{fomatterNum(item.pageCumulativeNum)}} 浏览
                  </div>
                </div>
                <div class="canEat-recipe" v-if="item.recommendType==1">
                  食谱推荐
                </div>
              </div>
              <!-- 商品卡片 -->
              <div class="swiper-slide-card" v-if="item.recommendType==2">
                <div class="canEat-img" v-if="item.recommendType==2">
                  <img style="object-fit: cover !important;" :src="item.pic" alt="" :onerror="shopImg">
                </div>
                <div class="shop-cent" v-if="item.recommendType==2">
                  <div class="shop-title">
                    {{item.productName}}
                  </div>
                  <div class="shop-txt" v-if="item.sales_price.promotion_type==6">
                    {{item.sales_price.point_value}}积分
                  </div>
                  <div class="shop-txt" v-else-if="item.sales_price.promotion_type==8&&item.sales_price.flag==1">
                    {{item.sales_price.point_value}}积分/￥{{item.sales_price.value}}
                  </div>
                  <div class="shop-txt" v-else-if="item.sales_price.promotion_type==8&&item.sales_price.flag==0">
                    {{item.sales_price.point_value}}积分+￥{{item.sales_price.value}}
                  </div>
                  <div class="shop-txt" v-else-if="item.sales_price.promotion_type==7">
                    ￥{{item.value}}
                  </div>
                  <s class="shop-num" v-if="item.sales_price.line_value">
                    ￥{{item.sales_price.line_value}}
                  </s>
                </div>
                <div class="tagWrap">
                  <openWxTag
                    :id="'xmyxItem'+ item.productId"
                    :path="'/subPackages/shopMainProcess/product/index?productId='+item.productId+'&skuId='+item.goodsId+'&actionLinkCode=10013'"
                    btnStyle="width:100%;height:120px"
                    @sensorsFn="goto(item)"
                  >
                  </openWxTag>
                </div>
                <!-- <a :href="item.jumpUrl" class="shop_a" v-if="item.recommendType==2"></a> -->
              </div>
            </div>
          </mySwiper>
          <div v-if="eatList.length === 1">
            <!-- 食谱卡片 -->
            <div
              class="swiper-slide"
              v-for="(item, index) in eatList"
              :key="index"
              @click="goto(item)"
            >
              <div class="swiper-slide-card" v-if="item.recommendType==1">
                  <div class="canEat-img" v-if="item.recommendType==1">
                  <img style="object-fit: cover !important;" :src="item.img_url" alt="" :onerror="supplementImg">
                </div>
                <div class="canEat-cent" v-if="item.recommendType==1">
                  <div class="canEat-title">
                    {{item.recommendInfo}}
                  </div>
                  <div class="canEat-txt">
                    {{item.recommendName}}
                  </div>
                  <div class="canEat-num">
                    {{fomatterNum(item.pageCumulativeNum)}} 浏览
                  </div>
                </div>
                <div class="canEat-recipe" v-if="item.recommendType==1">
                  食谱推荐
                </div>
              </div>
              <!-- 商品卡片 -->
              <div class="swiper-slide-card" v-if="item.recommendType==2">
                <div class="canEat-img" v-if="item.recommendType==2">
                  <img style="object-fit: cover !important;" :src="item.pic" alt="" :onerror="shopImg">
                </div>
                <div class="shop-cent" v-if="item.recommendType==2">
                  <div class="shop-title">
                    {{item.productName}}
                  </div>
                  <div class="shop-txt" v-if="item.sales_price.promotion_type==6">
                    {{item.sales_price.point_value}}积分
                  </div>
                  <div class="shop-txt" v-else-if="item.sales_price.promotion_type==8&&item.sales_price.flag==1">
                    {{item.sales_price.point_value}}积分/￥{{item.sales_price.value}}
                  </div>
                  <div class="shop-txt" v-else-if="item.sales_price.promotion_type==8&&item.sales_price.flag==0">
                    {{item.sales_price.point_value}}积分+￥{{item.sales_price.value}}
                  </div>
                  <div class="shop-txt" v-else-if="item.sales_price.promotion_type==7">
                    ￥{{item.value}}
                  </div>
                  <s class="shop-num" v-if="item.sales_price.line_value">
                    ￥{{item.sales_price.line_value}}
                  </s>
                </div>
                <div class="tagWrap">
                  <openWxTag
                    id="xmyxItem"
                    :path="'/subPackages/shopMainProcess/product/index?productId='+item.productId+'&skuId='+item.goodsId+'&actionLinkCode=10013'"
                    btnStyle="width:100%;height:120px"
                    @sensorsFn="goto(item)"
                  >
                  </openWxTag>
                </div>
                <!-- <a :href="item.jumpUrl" class="shop_a" v-if="item.recommendType==2"></a> -->
              </div>
            </div>
          </div>
      </div>
      <!-- 列表 -->
      <div class='list'>
        <div class="explain_item" v-for="(item,index) in detailObj.phaseList" :key="index">
          <div class="title">
            <div class="captxt">{{item.title}}</div>
            <div class="icon" :style="item.icon | color">
              <div :class="'criteria'+item.icon"></div>
              <font class="font" :style="item.icon | color" v-if="item.title==='婴幼儿'&&detailObj.tag">{{detailObj.tag}}+ &nbsp;</font>
              <font class="font" :style="item.icon | color">{{item.icon | word}}</font>
            </div>
          </div>
          <div class="article">{{item.text}}</div>
        </div>
      </div>
      <!-- 小贴士 -->
      <div class="tips" v-if="detailObj.tips">
        <div class="tips_content">
          <Caption type="simple font16" class="smail_tips">
            <img class="tips_icon" src="./../../assets/images/canEat/tip_icon.png" alt="">
            <font class="font">小贴士</font>
          </Caption>
          <p>{{detailObj.tips}}</p>
        </div>
      </div>
      <!-- 选购攻略 -->
      <div class="select" v-if="detailObj.strategy">
        <Caption type="font18">选购攻略</Caption>
        <div  class="article">{{detailObj.strategy}}</div>
      </div>
      <!-- 参考文献 -->
      <div class="reference" v-if="detailObj.referencesInformation">
        <Caption type="font18" class="grey">参考文献</Caption>
        <div class="txt" v-html="detailObj.referencesInformation"></div>
      </div>
    </section>
  </div>
</template>

<script>
import { Exposurer_eatToolsDetails } from '@/assets/js/Exposure'
import { fomatterNum,getCookie, is_weixin } from "@/assets/js/common.js";
import mySwiper from "@/components/common/mySwiper/mySwiper.vue";
import Caption from './components/Caption'
import canEatApi from "@/utils/axiosApi/canEatApi"
import openWxTag from "@/components/common/openWeappTag/index.vue" // 打开小程序开放标签
  export default {
    name: 'CanEatDetail',
    data() {
      return {
        detailObj: {},
        id: '',
        eatList:[],
        baby:"",
        baby_day:0,
        babyList:[],

      }
    },
    components: {
      Caption,
      mySwiper,
      openWxTag
    },
    created(){
      const oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js';
      document.body.appendChild(oScript);
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (vm.is_weixin()) { // 微信中
          if (vm.getCookie("xmh_openid") == null
           || vm.getCookie("xmh_openid") == ""
          ) { // 判断有没有openId
            location.href = "/xmh/v2/wechat/oauth2/authorize?url=" + encodeURIComponent(window.location.href);
          } else {
            vm.userOpenid = vm.getCookie('xmh_openid')
            vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
            vm.wxJsSet.getUserInfoBywx(vm, function () {
              vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
              gio('setUserId', vm.UserInfo.crm_id);
              if (vm.UserInfo.mobile == null
                || vm.UserInfo.mobile == ""
                || vm.UserInfo.mobile == "null"
              ) { // 没有手机号 未注册
                sensors.login(vm.getCookie('xmh_unionid'))
                vm.profileShow = false;
                vm.loginShow = true;
              } else {
                vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
                sensors.login(vm.UserInfo.crm_id)
                if (vm.UserInfo.mobile == vm.UserInfo.full_name) {
                  if (vm.getCookie('xmh_nickname') == '') {
                    vm.userName = vm.UserInfo.full_name
                  } else {
                    vm.userName = vm.getCookie('xmh_nickname')
                  }
                } else {
                  vm.userName = vm.UserInfo.full_name
                }
                vm.profileShow = true;
                vm.loginShow = true;
              }
            }, function () {
              if (vm.UserInfo == null
                || vm.UserInfo == ""
                || vm.UserInfo.mobile == null
                || vm.UserInfo.mobile == ""
                || vm.UserInfo.mobile == "null"
              ) { // 没有手机号 未注册
                sensors.login(vm.getCookie('xmh_unionid'))
                vm.profileShow = false;
                vm.loginShow = true;
                vm.$router.replace('/canEatList');
              } else {
                vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
                sensors.login(vm.UserInfo.crm_id)
                if (vm.UserInfo.mobile == vm.UserInfo.full_name) {
                  if (vm.getCookie('xmh_nickname') == '') {
                    vm.userName = vm.UserInfo.full_name
                  } else {
                    vm.userName = vm.getCookie('xmh_nickname')
                  }
                } else {
                  vm.userName = vm.UserInfo.full_name
                }
                vm.profileShow = true;
                vm.loginShow = true;
              }
            });
          }
        } else {
          vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
          if (vm.getCookie("xmh_phone") == null
            || vm.getCookie("xmh_phone") == ""
            || vm.UserInfo == null
            || vm.UserInfo == ""
          ) { // 未登录
            sensors.login(vm.getCookie('xmh_unionid'))
            vm.profileShow = false;
            vm.loginShow = true;
          } else {
            sensors.login(vm.UserInfo.crm_id)
            if (vm.UserInfo.mobile == vm.UserInfo.full_name) {
              if (vm.getCookie('xmh_nickname') == '') {
                vm.userName = vm.UserInfo.full_name
              } else {
                vm.userName = vm.getCookie('xmh_nickname')
              }
            } else {
              vm.userName = vm.UserInfo.full_name
            }
            vm.profileShow = true;
            vm.loginShow = true;
          }
        }
      })
    },
    mounted() {
      document.title = this.$route.query.nape
      this.id = this.$route.params.id
      this.getList() // 获取推荐详情列表数据
      this.shareFn()  // 分享
      this.getrepicList()//获取食谱/商品
      setTimeout(() => {
        const data = JSON.parse(localStorage.getItem("toolEatPoint")) || {};
        Exposurer_eatToolsDetails.observe('.can_eat_detail_page', false, {
          Pregnancy_Weeks: data.Pregnancy_Weeks,
          Baby_Month: data.Baby_Month,
          Gestate_State: data.Gestate_State,
          Visit_Channel: data.Visit_Channel,
          FoodName:this.$route.query.nape,
          Eatable_State:localStorage.getItem('monthAge'),
          module_name:'能不能吃-详情',
          per_page_name:'能不能吃-详情',
          per_module_name:'能不能吃'
        })
      }, 2000)

    },
    methods: {
      fomatterNum,is_weixin, getCookie,
      shareFn() {
        var that = this;
        var shareUrl = location.href.split('#')[0] + "&isLoginShare=1&isShare=1" // isLoginShare是否登录 share分享页
        var shareDataParams = {
          shareLink: shareUrl,
          shareDesc: '快来星妈会找找答案吧！',
          shareTitle: "孕育女性/小孩/老人，能不能吃"+ this.$route.query.nape +"？",
          imgUrl: "https://image-mom.feihe.com/wxshare/home.png",//必须是绝对路径
          shareSuccess: function () {
            that.$toast({
              duration: 2000,
              message: '分享成功'
            })
          }
        }
        this.wxJsSet.wxShare("fx", shareDataParams, this);
      },
      goBack() {
        if(this.$route.query.isShare) {
          this.$router.push({
            path: '/home'
          })
        } else {
          this.$router.back(-1);
        }
      },
      getList() { // 获取推荐详情列表数据
        var monthAge
        if(localStorage.getItem('monthAge')==null || localStorage.getItem('monthAge')==""){
          monthAge=4
        }else{
          monthAge=Number(localStorage.getItem('monthAge'))
        }
        canEatApi.getSecDetail({id: this.id, state: monthAge}, (res) => {
          if (res.code == '200') {
            if((this.$route.query.isShare && res.data == null)
              || (this.$route.query.isShare && res.data == '{}')
            ) {
              this.$router.replace({
                path: '/canEatList',
                query: {
                  isShare: this.$route.query.isShare
                }})
            }
            this.detailObj = res.data
          }
        })
      },
      goto(item){
        console.log(item);
        var str=""
        if(item.recommendType==1){
          str="食谱"
          sensors.track('Eatable_Details_Recommend', {
            FoodName: item.recommendName,
            Recommendt_Type: str,
            Recommendt_Title: item.recommendInfo,
            module_name:'能不能吃-详情',
            per_page_name:'能不能吃-详情',
            per_module_name:'能不能吃'
          })
          this.$router.push({
            path:"/foodColumn/foodDetail/"+item.id
          })
        }else if(item.recommendType==2){
          str="商品"
          sensors.track('Eatable_Details_Recommend', {
            FoodName: item.productName,
            Recommendt_Type: str,
            Recommendt_Title: item.productName,
            module_name:'能不能吃-详情',
            per_page_name:'能不能吃-详情',
            per_module_name:'能不能吃'
          })
          // location.href=item.jumpUrl
        }

        if(item.recommendType==1){

        }else if(item.recommendType==2){
        }
      },
      getrepicList() { //获取推荐的商品和食谱
        canEatApi.getListByFoodId({foodId:this.id},(res)=>{
            console.log(res.data);
            this.eatList=res.data
        })
      },
      deepcp(arr1,arr2){//数组深拷贝方法
        for (var i = 0; i < arr1.length; i++) {
            arr2.push(arr1[i]);
        }
      }
    },
    filters: {
      filterpageData(num){
        num = Number(num);
        if (num == 0) {
          return num + '';
        } else
        if (num > 1 && num < 10000) {
          return num + '';
        } else {
          var str=(num / 10000).toFixed(1)
          if(str.charAt(str.length-1)==0){
          return (num / 10000).toFixed(0) + 'w';
          }
          return (num / 10000).toFixed(1) + 'w';
        }
			}
    },
    computed: {
        // 计算
        num1(){
        let res=0;
          res=this.eatList.length
        return res
        },
        supplementImg () {
            return 'this.src="' + require('../../assets/images/canEat/supplement.png') + '"';
        },
        shopImg () {
            return 'this.src="' + require('../../assets/images/canEat/shop.png') + '"';
        }
    }
  }
</script>

<style lang="less" scoped>
.can_eat_detail_page {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  .gobackBtn {
    z-index: 100;
    width: 26px;
    position: fixed;
    top: 6px;
    left: 12px;
    img {
      width: 26px;
      height: 26px;
    }
  }
  .section {
    width: 100%;
    flex: 1;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    .introduction {
      width: 100%;
      .review{
        width: 100%;
        box-sizing: border-box;
        padding: 14px 22px 0 22px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
        word-wrap:break-word;
        .review-icon{
          width: 12px;
          height: 12px;
          float: left;
          padding-top: 1px;
          padding-right: 6px;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
      // .pic {
        .picture {
          width: 100%;
        }
      // }
      .intro {
        padding: 0 22px;
        box-sizing: border-box;
        margin-top: 23px;
      }
      .explain { // 别名内容
        padding: 0 22px;
        box-sizing: border-box;
        .tips_content {
          background: #F7F7F7;
          border-radius: 8px;
          padding: 5px 10px 10px;
          box-sizing: border-box;
          margin-top: 20px;
          margin-bottom: 22px;
          .smail_tips {
            display: flex;
            align-items: center;
            height: 18px;
            .tips_icon {
              width: 19px;
              height: 18px;
            }
            .font {
              height: 18px;
              font-size: 16px;
              color: #333333;
              line-height: 18px;
              margin-left: 2px;
            }
          }
          p {
            font-size: 12px;
            color: #333333;
            line-height: 22px;
          }
        }
      }
    }
    .swiper-car{
      margin: 10px 22px 16px;
      width: 331px;
      height: 120px;
      background: #FFFFFF;
      box-shadow: 0px 3px 10px 0px rgba(200, 201, 204, 0.5);
      border-radius: 8px;
      overflow: hidden;
      // overflow-x: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      .swiper-slide{
        height: 120px;
        border-radius: 8px;
        overflow: hidden;
        background-size: cover;
        background-position: center center;
        display: flex;
        position: relative;
        .swiper-slide-card{
          width: 100%;
          height: 100%;
          display: flex;
          .canEat-img{
            width: 92px;
            height: 92px;
            margin: 14px 8px;
            display: flex;
            justify-content: center;
            text-align: center;
            overflow: hidden;
            align-items: center;
            img{
              width: 92px;
              height: 92px;
            }
          }
          .canEat-recipe{
            width: 70px;
            height: 26px;
            background: #FD6E40;
            border-radius: 0px 8px 0px 8px;
            position: absolute;
            top: 0;
            right: 0;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 26px;
            text-align: center;
          }
          .canEat-cent{
            width: 220px;
            height: 92px;
            margin: 14px 8px;
            .canEat-title{
              width: 144px;
              height: 20px;
              font-size: 14px;
              font-family: PingFang-SC-Medium, PingFang-SC;
              font-weight: 500;
              color: #333333;
              line-height: 20px;
              max-width: 144px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .canEat-txt{
              margin-top: 18px;
              width: 144px;
              height: 20px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 18px;
            }
            .canEat-num{
              margin-top: 18px;
              width: 144px;
              height: 20px;
              font-size: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #CCCCCC;
              line-height: 14px;
            }
          }
          .shop-cent{
            width: 220px;
            height: 92px;
            margin: 14px 8px;
            .shop-title{
              width: 211px;
              height: 20px;
              font-size: 14px;
              font-family: PingFang-SC-Medium, PingFang-SC;
              font-weight: 500;
              color: #333333;
              line-height: 20px;
              max-width: 211px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .shop-txt{
              margin-top: 18px;
              width: 100%;
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #FD6E40;
              line-height: 20px;
            }
            .shop-num{
              display: block;
              margin-top: 18px;
              width: 100%;
              height: 14px;
              font-size: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #CCCCCC;
              line-height: 14px;
            }
          }
          .shop_a{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
          .tagWrap{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
        }

      }
    }
    .list {
      width: 100%;
      padding: 0 22px;
      box-sizing: border-box;
      .explain_item {
        margin-top: 22px;
        // position: relative;
        &:nth-of-type(1) {
          margin-top: 0;
        }
        .title{
          width: 100%;
          height: 45px;
          overflow: hidden;
          .captxt{
            text-indent: 0;
            float: left;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 40px;
          }
          .icon {
            display: flex;
            align-items: center;
            height: 20px;
            font-size: 14px;
            font-weight: normal;
            padding: 3px 5px;
            box-sizing: border-box;
            margin-bottom: 7px;
            margin-top: 12.5px;
            >div {
              // margin-top: 2px;
              width: 14px;
              height: 15px;
              margin-right: 4px;
              // margin-bottom: 4px;
              // background: url(../../assets/images/canEat/0.png) no-repeat left / 100%;
              // display: flex;
              // align-items: center;
              // justify-content: center;
              // line-height: 14px;
              // box-sizing: border-box;
              >img {
                width: 14px;
                max-height: 14px;
                // vertical-align: middle;
              }
            }
            .criteria0{
              background: url(../../assets/images/canEat/0.png) no-repeat left / 100%;
            }
            .criteria1{
              background: url(../../assets/images/canEat/1.png) no-repeat left / 100%;
            }
            .criteria2{
              background: url(../../assets/images/canEat/2.png) no-repeat left / 100%;
            }
            .criteria3{
              background: url(../../assets/images/canEat/3.png) no-repeat left / 100%;
            }
            .font {
              font-size: 14px;
              height: 14px;
              color: #333333;
              line-height: 14px;
            }
          }
        }
        .article{
          width: 100%;
          color: #333333;
          font-size: 14px;
          line-height: 26px;
          // word-wrap:break-word;
          word-break: break-all;
        }
      }
    }
    .tips {
      padding: 0 22px;
      box-sizing: border-box;
      .tips_content {
        background: #F7F7F7;
        border-radius: 8px;
        padding: 5px 10px 10px;
        box-sizing: border-box;
        margin-top: 20px;
        .smail_tips {
          display: flex;
          align-items: center;
          height: 18px;
          .tips_icon {
            width: 19px;
            height: 18px;
          }
          .font {
            height: 18px;
            font-size: 16px;
            color: #333333;
            line-height: 18px;
            margin-left: 2px;
          }
        }
        p {
          font-size: 12px;
          color: #333333;
          line-height: 22px;
        }
      }
    }
    .select {
      padding: 0 22px 32px;
      box-sizing: border-box;
      margin-top: 20px;
    }
    .article {
      width: 100%;
      color: #333333;
      font-size: 14px;
      line-height: 26px;
      word-wrap:break-word;
    }
    .reference{
      padding: 0 22px 32px;
      .grey{
        color: #999999;
      }
      .txt{
        white-space: pre-line;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 26px;
        word-wrap:break-word;
      }
    }
  }
  .txt1{
        padding: 0 22px 32px;
        white-space: pre-line;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 26px;
        word-wrap:break-word;
      }
}
</style>
